var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecording = function SvgRecording(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6097",
    "data-name": "Grupo 6097",
    transform: "translate(-384 -347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2305",
    "data-name": "Ret\\xE2ngulo 2305",
    width: 88,
    height: 88,
    rx: 20,
    transform: "translate(384 347)",
    fill: "#8a98e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spatial_audio_off_50dp_5F6368",
    transform: "translate(401.117 364.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6093",
    "data-name": "Grupo 6093"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2307",
    "data-name": "Ret\\xE2ngulo 2307",
    width: 55,
    height: 55,
    transform: "translate(-0.117 -0.117)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6095",
    "data-name": "Grupo 6095",
    transform: "translate(5.514 2.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6094",
    "data-name": "Grupo 6094"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_192",
    "data-name": "Elipse 192",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(8.368 11.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8557",
    "data-name": "Caminho 8557",
    d: "M32.411,15.777a27.347,27.347,0,0,0-27.736,0A5.459,5.459,0,0,0,2,20.519v5.266H35.085V20.519A5.459,5.459,0,0,0,32.411,15.777Z",
    transform: "translate(-2 18.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8558",
    "data-name": "Caminho 8558",
    d: "M18.523,1,15.6,3.923a17.955,17.955,0,0,1,0,25.338l2.923,2.923A22.065,22.065,0,0,0,18.523,1Z",
    transform: "translate(21.897 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8559",
    "data-name": "Caminho 8559",
    d: "M16.4,3.12,13.48,6.043a9.685,9.685,0,0,1,0,13.648L16.4,22.613A13.8,13.8,0,0,0,16.4,3.12Z",
    transform: "translate(18.172 2.725)",
    fill: "#fff"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecording, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recording.043ca6ea.svg";
export { ForwardRef as ReactComponent };